<template>

    <trax-ui-ajax-form-in-modal icons="1" :id="id" :endpoint="endpoint" 
        :props="props" :titles="titles" :bus="bus" :form="form">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus'],
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"trax/api/front/roles",
                id: 'trax-account-role-edit',
                form: {},
                errors: {},
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    description: { source:'description' }
                },
                titles: {
                    new: lang.polaris.account.new_role,
                    update: lang.polaris.account.role_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        }

    }
</script>
